import styled from 'styled-components';
import {dFlexColumn, dFlex, alignCenter, justifyCenter} from '../../../../globalVariables/GlobalFlex';
import {BGImageCenter, BLACK, TURQUISE_BLUE, scrollbar, mobileMedia, WHITE, BRIGHT_RED} from '../../../../globalVariables/GlobalVariables';
import {arrowDark} from '../../../../assets/symbols/symbols/Symbols.css';
import {bottom, close} from '../../../newPopup/innerPop/InnerPop.css';

export const container = styled.div`
    ${close}{
        ${BGImageCenter(arrowDark, '20px')}
    }
    ${bottom}{
        gap: 8px;
    }
`;

export const headerContent = styled.div<{$headerHeight: 'short' | 'tall'; $headerImage?: string;}>`
    background: ${TURQUISE_BLUE};
    padding: 20px;
    position: relative;
    border-radius: 0 0 10px 10px;
    height: 120px;
    min-height: 120px;
    ${mobileMedia}{
        min-height: 120px;
    }
    ${p => p.$headerHeight === 'tall' && `
        height: 60%;
        min-height: 300px;
    `}
    ${p => p.$headerImage && `
        ::after {
            content: '';
            ${BGImageCenter(p.$headerImage, 'contain')}
            position: absolute;
            inset-inline-end: calc(50% - 103px);
            inset-block-start: calc(50% - 85px);
            width: 206px;
            height: 170px;
            ${mobileMedia}{
                width: 140px;
                height: 115px;
                inset-inline-end: calc(50% - 70px);
                inset-block-start: calc(50% - 57.5px);
            }
        }
    `}
`;

export const headerTitle = styled.div`
    font-size: 16px;
    font-weight: 400;
    color: ${BLACK};
    text-align: end;
    margin-bottom: 20px;
`;

export const mainContent = styled.div`
    padding: 20px;
    position: relative;
    ${scrollbar} 
    height: calc(100% - 160px);
`;

export const title = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: ${BLACK};
    text-align: center;
    line-height: 115.002%;
    padding-block-end: 20px;
`;

export const messageText = styled.div`
    text-align: center;
    margin-bottom: 20px;
`;

export const messageLine = styled.div`
    font-size: 14px;
    color: ${BLACK};
    margin-bottom: 8px;
    font-weight: 400;
    text-align: center;
    line-break: anywhere;
`;

export const warningIcon = styled.div`
    width: 117px;
    height: 117px;
    border: 13px solid rgba(255, 23, 68, 0.20);
    border-radius: 50%;
    background: ${WHITE};
    ${dFlex}
    ${alignCenter}
    ${justifyCenter}
    position: relative;
    inset-inline-start: calc(50% - 58.5px);
    margin-bottom: 20px;
    ${mobileMedia}{
        width: 90px;
        height: 90px;
        inset-inline-start: calc(50% - 45px);
    }
    &::before {
        content: '';
        position: absolute;
        top: -10px;
        left: -10px;
        right: -10px;
        bottom: -10px;
        border: 7px solid ${BRIGHT_RED};
        border-radius: 50%;
        pointer-events: none;
    }
`;

export const exclamationMark = styled.span`
    color: ${BRIGHT_RED};
    font-size: 32px;
    font-weight: 800;
    line-height: 36px;
`;

export const packagesContainer = styled.div`
    ${dFlexColumn};
    gap: 12px;
    width: 100%;
    max-width: 300px;
`;

export const sendApprovalContainer = styled.div`
    ${headerContent}{
        ::after {
            inset-inline-end: calc(50% - 65px);
            inset-block-start: 50px;
            width: 130px;
            height: 105px;
        }
    }
    ${mainContent}{
        inset-block-start: 40px;
    }
`;

export const upgradeModalContainer = styled.div`
    ${mainContent}{
        inset-block-start: -80px;
        ${mobileMedia}{
            inset-block-start: -60px;
        }
    }
`;
export const packageSelectionModalContainer = styled.div`
    ${headerContent}{
        ::after {
            inset-inline-end: calc(50% - 65.5px);
            inset-block-start: calc(50% - 42.5px);
            width: 127px;
            height: 105px;
        }
    }
`;
